import React, { FC } from 'react';
import styled from 'styled-components';
import { useWindowWidth } from 'utils/useWindowWidth';

const UpdateNotificationDiv = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--color-alt-second-10);
    padding: 12px 10px;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }
`;

const NotificationText = styled.span`
    text-align: center;
    
    @media (max-width: 767px) {
        padding-right: 25px;
    }
`;

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    
    @media (max-width: 767px) {
        flex-direction: column-reverse;
    }
`;

const UpdateButton = styled.button`
    background-color: var(--color-white);
    color: var(--color-primary); 
    border: none;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    
    &:hover {
        background-color: var(--color-primary);
        color: var(--color-white);
    }
    
    @media (max-width: 767px) {
        margin: 10px 0 0 0;
        width: 100%;
    }
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    color: var(--color-primary-70);
    border-radius: 50px;
    font-size: 16px;
    cursor: pointer;
    padding: 0 8px;
    
    &:hover {
        opacity: 0.8;
        background-color: var(--color-primary);
        color: var(--color-white);
    }
`;

interface UpdateNotificationBarProperties {
    refreshPage: () => void;
    closeNotification: () => void;
}

const UpdateNotificationBar: FC<UpdateNotificationBarProperties> = ({ refreshPage, closeNotification }) => {
    const width = useWindowWidth();

    return (
        <UpdateNotificationDiv>
            <div>
                <NotificationText>Dostępna jest nowa wersja aplikacji. Zapisz swoje zmiany, aby nie utracić danych i aktualizuj.</NotificationText>
                <ButtonsContainer>
                    <UpdateButton onClick={refreshPage}>{ width >= 768 ? 'Aktualizuj teraz' : 'Aktualizuj'}</UpdateButton>
                    <CloseButton onClick={closeNotification}>✕</CloseButton>
                </ButtonsContainer>
            </div>
        </UpdateNotificationDiv>
    );
};

export default UpdateNotificationBar;
